const subs = new Set();

export const setCursor = (time) => subs.forEach((f) => f(time));

export function onCursor(f) {
  subs.add(f);
  return () => subs.delete(f);
}

export const cursorProps = (data) => ({
  onMouseMove: (s) => {
    const i = s?.activeTooltipIndex;
    const row = i != null && i !== "" ? data[Number(i)] : null;
    setCursor(row ? row.x : null);
  },
  onMouseLeave: () => setCursor(null),
});
